// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgReload = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 17"
    {...props}
  >
    <path
      fill={props.color ?? 'currentColor'}
      d="m13.3 6.664-1.4 1.392c.4.695.7 1.49.7 2.285 0 2.485-2 4.472-4.5 4.472s-4.5-1.987-4.5-4.472c0-2.484 2-4.472 4.5-4.472h.1L6.9 7.161c-.4.398-.4.994 0 1.392.2.198.5.298.7.298s.5-.1.7-.298l3-2.982c.4-.397.4-.994 0-1.391l-3-2.981a.97.97 0 0 0-1.4 0c-.4.397-.4.993 0 1.39l1.3 1.293h-.1c-3.6 0-6.5 2.882-6.5 6.46S4.5 16.8 8.1 16.8s6.5-2.882 6.5-6.46c-.1-1.292-.6-2.583-1.3-3.677"
    />
  </svg>
)
export default SvgReload
